import anime from "animejs";

export default function initHeroTitleAnimation() {
  //animate hero title
  let textWrapper = document.querySelector('.hero-title .h1');
  if (textWrapper) {
    textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");

    let textArray = JSON.parse(textWrapper.dataset.text);
    let i = 0;
    let d = 0;

    anime.timeline({loop: false})
      .add({
        targets: '.hero-title .h1 .letter',
        translateX: [40, 0],
        translateZ: 0,
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1200,
        delay: (el, i) => 30 * i
      })
      .add({
        targets: '.hero-title .h1 .letter',
        translateX: [0, -30],
        opacity: [1, 0],
        easing: "easeInExpo",
        duration: 1200,
        delay: (el, i) => 30 * i
      });

    setInterval(() => {
      let el = textArray[i];
      textWrapper.innerHTML = el.replace(/\S/g, "<span class='letter'>$&</span>");

      anime.timeline({loop: false})
        .add({
          targets: '.hero-title .h1 .letter',
          translateX: [40, 0],
          translateZ: 0,
          opacity: [0, 1],
          easing: "easeOutExpo",
          duration: 1200,
          delay: (el, i) => 30 * i
        })
        .add({
          targets: '.hero-title .h1 .letter',
          translateX: [0, -30],
          opacity: [1, 0],
          easing: "easeInExpo",
          duration: 1200,
          delay: (el, i) => 30 * i
        });
      i++;

      if (i === textArray.length) i = 0;

      let j = 1;
      while (j <= textWrapper.querySelectorAll('.letter').length) {
        d += 30 * j;
        j++;
      }
    }, (2400 + d) * 1.5);
  }
}
